import * as React from 'react';
import { Caption } from '@cian/ui-kit';
import { IconToggleStarOn12 } from '@cian/ui-kit-design-tokens/icons';

import { TRatingColor } from './types';
import * as style from './Rating.css';

export interface IRatingMobileProps {
  color: TRatingColor;
  score: string;
  countText: string;
}

/** В мобильном макете рейтинг мельче десктопного: caption 12/16 и иконка 12px. */
export const RatingMobile = ({ color, score, countText }: IRatingMobileProps): React.JSX.Element => (
  <div className={style['container']}>
    <div className={style['score']}>
      <IconToggleStarOn12 color={color} />
      <Caption color={color}>{score}</Caption>
    </div>
    <Caption color="text-secondary-default">{countText}</Caption>
  </div>
);
